<template>
    <div>
        There are {{classNames.length}} classes in Akashic Paths. Classes do not dictate what kind of items you will have access to during the run, but only your base equipment and abilities. There are 6 martial and magic classes, and 4 hybrid classes.
        <v-row style="margin-top:20px;">
            <v-col>
                <h3>Martial:</h3>
                <li style="padding-left:22px" v-for="className in classNames.slice(0,6)" :key="className"><a @click="scrollTo(className)" >{{capitalize(className)}}</a></li>
            </v-col>
            <v-col>
                <h3>Hybrid:</h3>
                <li style="padding-left:22px" v-for="className in classNames.slice(6,10)" :key="className"><a @click="scrollTo(className)" >{{capitalize(className)}}</a></li>
            </v-col>
            <v-col>
                <h3>Magic:</h3>
                <li style="padding-left:22px" v-for="className in classNames.slice(10,15)" :key="className"><a @click="scrollTo(className)" >{{capitalize(className)}}</a></li>
            </v-col>    
        </v-row>
        <br/><br/>
        <table>
            <tr> <th>Name</th><th>Ability Scores</th><th>Base Stats</th><th>Starting Rolls</th></tr>
            <tr v-for="classRoll in classRolls" :key="classRoll.name"> <td style="text-align:center">{{classRoll.name}}</td><td style="padding-left:4px; padding-right:4px">{{classRoll.abilityScores}}</td><td style="padding-left:4px; padding-right:4px">{{classRoll.baseStats}}</td><td style="padding-left:4px">{{classRoll.Rolls}}</td></tr>
        </table>

        <br/><br/><br/>
        <h1 style="color:cornflowerblue">Class Perks:</h1
        >When you pick a class, you will get to choose between a small list of class specific perks. Then, as you level up in a class it gives you the ability to unlock permanent perks for it, each tier you get to pick one perk, however you can change your choice whenever you'd like, but this wont affect any current runs. 
        See <a href="/rules/akashicpathsrules">Akashic Path Rules</a> for more info        
        <div v-for="className in classNames" :key="className">
        <h2 :id="className" style="text-align:center">{{capitalize(className)}}:</h2>
        <v-divider></v-divider><br/>
        <h3 style="text-align:center">Class Perks:</h3>
        <table>
            <tr v-for="perk in getClassPerks(className)" :key="perk.name">
                <td style="width:4%">
                   {{perk.name}}
                </td>
                <td style="width:30%">
                    {{perk.description}}
                </td>
            </tr>
        </table><br/><br/>
        <h3 style="text-align:center">Tier Perks:</h3>
        <table>
            <tr v-for="tier in getPerks(className)" :key="tier[0]"> 
                <td style="width:4%; text-align:center">
                   Tier {{tier[0][4]}}
                </td>
                <td style="width:30%">
                    <h3 style="text-align:center">{{tier[1][0].name}}</h3>
                    <br/>
                    <div style="width:100%; text-align:center">
                        {{tier[1][0].desc}}
                    </div>
                </td>
                <td  style="width:30%">
                    <h3 style="text-align:center">{{tier[1][1].name}}</h3>
                    <br/>
                    <div style="width:100%; text-align:center">
                        {{tier[1][1].desc}}
                    </div>
                </td>
                <td  style="width:30%">
                    <h3 style="text-align:center">{{tier[1][2].name}}</h3>
                    <br/>
                    <div style="width:100%; text-align:center">
                        {{tier[1][2].desc}}
                    </div>
                </td>
            </tr>
        </table>
        <br/><br/>
        </div>
        <v-icon style="position:fixed; right:16px; bottom:16px; color:cornflowerblue" outlined large @click="scrollTo('top')">mdi-arrow-up-circle</v-icon>
    </div>
</template>
<script>
//
import {classRoll, levelUpPerks} from "../../../play/data"
export default {
  props:{
  },
  mounted(){

  },
  data(){
      return{
            classRolls:[...classRoll],
            classNames:["fighter","barbarian","rogue","tank","ranger","monk","warpriest","eldritchKnight","arcaneTrickster","prodigy","wizard","cleric","shaman","alchemist","sorcerer"]
      }
  },
  methods:{
    getPerks(className){
        let data = Object.entries(levelUpPerks[className])
        return data
    },
    getClassPerks(className){
        let classDB = classRoll.find(classRoll=> classRoll.name == this.capitalize(className))
        return classDB.classPerks
    },
    scrollTo(id){
        if(id == 'top'){
            window.scrollTo({top: 0, behavior: 'instant'});
        }else{
            let element = document.getElementById(id);
            let y = element.getBoundingClientRect().top - 64;
            window.scrollTo({top: y, behavior: 'smooth'});
        }
    },  

    capitalize(str){  
        for(let x = 0; x < str.length; x++){
            if(str[x].toUpperCase() == str[x]){
                str = str.substring(0,x) + " " + str.substring(x,str.length)
                break;
            }
        }            
        let newStr = str[0].toUpperCase() + str.substring(1)
        return newStr
      },
  }

}
</script>
<style scoped>
table, th, td {
  border:1px solid black;
}
</style>